import { ReferenceSection } from "../../common";
import { getColCount } from "./referenceColumns";

export interface TrainableRow {
    firstColumn: string;
    restColumns: string[];
    cells: string[];
}

export interface TrainableTable {
    title: string;
    header: string[] | null;
    colCount: number;
    rows: TrainableRow[];
}

export function getTrainableTables(sections: ReferenceSection[]): TrainableTable[] {
    const tables: TrainableTable[] = [];

    for (const section of sections) {
        const colCount = getColCount(section);
        if (colCount < 2)
            continue;

        const rows: TrainableRow[] = section.rows
            .filter(row => !row.highlight && row.cells.length === colCount)
            .map(row => ({
                firstColumn: row.cells[0],
                restColumns: row.cells.slice(1),
                cells: row.cells,
            }));

        if (rows.length === 0)
            continue;

        tables.push({
            title: section.title,
            header: section.header,
            colCount,
            rows,
        });
    }

    return tables;
}

export function hasTrainableTables(sections: ReferenceSection[]): boolean {
    return getTrainableTables(sections).length > 0;
}
